export const PAGINATION_OPTIONS = {
  DEFAULT_PAGINATION_NUMBER_OF_ITEMS_PER_PAGE: 15,
};

export default PAGINATION_OPTIONS;
